<template>
  <div class="container menus">
    <van-cell-group class="menus__list">
      <van-cell title="姓名" size="large" is-link @click="linkComponents" />
      <van-cell title="身份证" size="large" is-link @click="linkComponents" />
      <van-cell title="手机号码" size="large" type="info" :value="Phone" is-link @click="linkComponents" />
    </van-cell-group>
  </div>
</template>

<script>
import { CellGroup } from 'vant'
import { getLocalStorage } from '@/utils/auth'
export default {
  name: 'Wallet',
  components: {
    [CellGroup.name]: CellGroup
  },
  data () {
    return {
      Phone: null,
    }
  },

  mounted () {
    this.Phone = getLocalStorage('NINEBITSS').phone
  },
  destroyed () {  // 销毁时取消监听
  },
  methods: {
    // 跳转
    linkComponents () {
      this.$toast('暂未开通 敬请期待！')
    }
  }
}
</script>

<style lang="scss" scoped>
.menus {
  height: 100vh;
  background: #f4f6f7;

  &__list {
    &__icon {
      font-size: 20px;
      line-height: 24px;
      margin-right: 5px;
      height: 24px;
    }
  }
}
</style>